import React, { Suspense, useState } from 'react';

import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';
import { Notification, ReviewCompleteModal, ReviewWriteDialog } from 'features/notification';
import { ReviewServiceType } from 'shared/types';

import { useGetNotificationCheck } from '../api/query';
import { NotificationIcon as NotificationIconIcon } from './Icons';

export function NotificationIcon() {
  const { data: hasNotification } = useGetNotificationCheck();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isReviewDialogOpen, setIsReviewDialogOpen] = useState(false);
  const [isReviewCompleteModalOpen, setIsReviewCompleteModalOpen] = useState(false);

  const [orderId, setOrderId] = useState<number>(0);
  const [reviewTargetServiceType, setReviewTargetServiceType] = useState<ReviewServiceType>('ALL');

  return (
    <div>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <PopoverTrigger asChild>
          <button
            aria-label="notice"
            className="relative flex h-[24px] w-[24px] items-center justify-center"
            onClick={() => {
              window.dataLayer?.push({
                event: 'click_menu',
                menu: 'notice',
                section: 'Header',
              });
            }}
          >
            <NotificationIconIcon />
            {hasNotification && <div className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-primary"></div>}
          </button>
        </PopoverTrigger>

        <PopoverContent className="rounded-[20px] p-0" align="end" collisionPadding={16}>
          <Suspense fallback={null}>
            <Notification
              onOpenReviewDialog={(orderId: number) => {
                setIsPopoverOpen(false);
                setIsReviewDialogOpen(true);
                setOrderId(orderId);
                setReviewTargetServiceType(reviewTargetServiceType);
              }}
            />
          </Suspense>
        </PopoverContent>
      </Popover>

      {/* 헤더는 페이지 Suspense 바깥이라, 'review' 번역 파일을 기다리는 동안 여기서 받아줘야 한다.
          (없으면 로그인·가입 직후 알림 아이콘이 처음 뜰 때 전체가 server error 화면으로 넘어감) */}
      <Suspense fallback={null}>
        <ReviewWriteDialog
          isOpen={isReviewDialogOpen}
          onClose={() => setIsReviewDialogOpen(false)}
          onSubmit={() => setIsReviewCompleteModalOpen(true)}
          orderId={orderId}
          reviewTargetServiceType={reviewTargetServiceType}
        />
        <ReviewCompleteModal
          isOpen={isReviewCompleteModalOpen}
          onClose={() => setIsReviewCompleteModalOpen(false)}
          orderId={orderId}
        />
      </Suspense>
    </div>
  );
}
